import { RuleModel } from './rule-model';

export class RulesTemplateModel {
  rules: RuleModel[];
  version: number;
}
